import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div style={{ textAlign: 'center', padding: '100px 20px' }}>
      <h1 style={{ fontSize: '6rem', color: '#8B0000', marginBottom: '20px' }}>404</h1>
      <h2>Page Not Found</h2>
      <p style={{ fontSize: '1.2rem', margin: '30px 0' }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/">
        <button className="button" style={{ padding: '15px 30px', fontSize: '1.2rem' }}>
          Return Home
        </button>
      </Link>
    </div>
  );
};

export default NotFoundPage;